var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.50016C2.5 6.57969 3.24619 5.8335 4.16667 5.8335H4.94167C5.4988 5.83358 6.01913 5.55528 6.32833 5.09183L7.005 4.07516C7.31421 3.61171 7.83454 3.33341 8.39167 3.3335H11.6083C12.1655 3.33341 12.6858 3.61171 12.995 4.07516L13.6717 5.09183C13.9809 5.55528 14.5012 5.83358 15.0583 5.8335H15.8333C16.7538 5.8335 17.5 6.57969 17.5 7.50016V15.0002C17.5 15.9206 16.7538 16.6668 15.8333 16.6668H4.16667C3.24619 16.6668 2.5 15.9206 2.5 15.0002V7.50016V7.50016",
    stroke: "#0891B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8335C12.5 12.2133 11.3798 13.3335 10 13.3335C8.62021 13.3335 7.5 12.2133 7.5 10.8335C7.5 9.45371 8.62021 8.3335 10 8.3335C11.3798 8.3335 12.5 9.45371 12.5 10.8335V10.8335",
    stroke: "#0891B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiCameraIcon);
export default __webpack_public_path__ + "static/media/kpi_camera_icon.c4188758ad89aea7cff28d23f4f71d1c.svg";
export { ForwardRef as ReactComponent };